import React from 'react';
import PropTypes from 'prop-types';
import { TableCardHeader } from 'react-md';
import { injectIntl } from 'react-intl';
import SpeedingBadges from '../SpeedingBadges';
import { overspeedsSums } from '../../utils/reducers';
import ContestDialog from './ContestDialog';


const SegmentsTableActions = ({
  onReportClick, onRejectClick, journey, intl: { formatMessage }, userAttributes, selectedRows,
}) => (
  <TableCardHeader
    title={formatMessage({ id: 'journeyDetails.speeding' })}
    className="card-title-header"
    visible={selectedRows.length > 0}
    contextualTitle={`${selectedRows.length} ${formatMessage({ id: 'journeyDetails.itemsSelected' }, { value: selectedRows.length })}`}
    actions={[
      <ContestDialog
        segment={selectedRows}
        onClickReportError={onReportClick}
        onClickRejectError={onRejectClick}
        userAttributes={userAttributes}
        style={{ color: '#FFFFFF' }}
      />,
    ]}
  >
    <SpeedingBadges className="md-cell--right" {...overspeedsSums(journey.stats.byOccurences)} />
  </TableCardHeader>
);

SegmentsTableActions.propTypes = {
  onReportClick: PropTypes.func,
  onRejectClick: PropTypes.func,
  intl: PropTypes.object,
  journey: PropTypes.object,
  userAttributes: PropTypes.shape({
    isPsy: PropTypes.bool.isRequired,
  }).isRequired,
  selectedRows: PropTypes.array.isRequired,
};

export default injectIntl(SegmentsTableActions);



// WEBPACK FOOTER //
// ./src/components/Journey/SegmentsTableActions.js